import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Star, Home, Users, Mail, Play, ThumbsUp } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { to: '/', label: 'Inicio', icon: Home },
    { to: '/servicios', label: 'Servicios', icon: Users },
    { to: '/galeria', label: 'Galería', icon: Play },
    { to: '/contacto', label: 'Agendar', icon: Mail },
    { to: '/social', label: 'Social', icon: ThumbsUp }
  ];

  const Icon = ({ component: Component }) => (
    <Component size={22} className="mr-2 text-yellow-400" />
  );

  return (
    <motion.nav
      className="fixed top-0 w-full bg-black/30 backdrop-blur-xl border-b border-blue-500/40 shadow-lg z-50"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className="container mx-auto px-6 py-4 flex justify-between items-center">
        
        {/* LOGO */}
  <motion.div
  className="flex flex-col text-2xl font-bold text-yellow-300 tracking-wide"
  whileHover={{ scale: 1.03 }}
>
  <span>Profesor Juan de la Cruz</span>
  <motion.span
    className="h-[3px] w-0 bg-yellow-400 rounded-full mt-1"
    whileHover={{ width: "100%" }}
    transition={{ duration: 0.4 }}
  />
</motion.div>


        {/* NAV DESKTOP */}
        <div className="hidden md:flex items-center gap-6">
          {navItems.map((item) => {
            const active = location.pathname === item.to;

            return (
              <Link to={item.to} key={item.to} className="w-full">
                <motion.div
                  whileHover={{ scale: 1.1, y: -4 }}
                  transition={{ duration: 0.25 }}
                  className={`flex items-center px-5 py-2 rounded-full font-medium cursor-pointer transition-all
                    ${active 
                      ? 'bg-blue-900/70 text-yellow-300 shadow-lg border border-yellow-400/20'
                      : 'text-yellow-300/80 hover:text-yellow-300 hover:bg-black/20'
                    }
                  `}
                >
                  <Icon component={item.icon} />
                  <span>{item.label}</span>
                </motion.div>
              </Link>
            );
          })}
        </div>

        {/* BOTÓN MOBILE */}
        <motion.button
          className="md:hidden text-yellow-400 p-2"
          onClick={() => setIsOpen(!isOpen)}
          whileHover={{ scale: 1.15 }}
          whileTap={{ scale: 0.9 }}
        >
          {isOpen ? <X size={26} /> : <Menu size={26} />}
        </motion.button>
      </div>

      {/* NAV MOBILE */}
      {isOpen && (
        <motion.div
          className="md:hidden bg-black/40 backdrop-blur-xl border-t border-blue-500/40"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          transition={{ duration: 0.3 }}
        >
          <div className="container mx-auto px-6 py-6 flex flex-col gap-4">
            {navItems.map((item) => {
              const active = location.pathname === item.to;

              return (
                <Link to={item.to} key={item.to} onClick={() => setIsOpen(false)} className="w-full">
                  <motion.div
                    whileHover={{ x: 10, scale: 1.03 }}
                    transition={{ duration: 0.25 }}
                    className={`flex items-center py-3 px-4 rounded-xl font-medium cursor-pointer
                      ${active
                        ? 'bg-blue-900/60 text-yellow-300'
                        : 'text-yellow-300/80 hover:bg-black/30'
                      }
                    `}
                  >
                    <Icon component={item.icon} />
                    <span>{item.label}</span>
                  </motion.div>
                </Link>
              );
            })}
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;
